import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import './progressRing.html';
import './progressRing.scss';

export interface ProgressRingVMConfig {
    value: SubscribableOrNullableValue<number>

    strokeWidth?: SubscribableOrNullableValue<number>
    color?: SubscribableOrNullableValue<string>
    backgroundColor?: SubscribableOrNullableValue<string>
    size?: SubscribableOrNullableValue<number>
}

@injectable()
export default class ProgressRingVM {
    color: Subscribable<string>
    backgroundColor: Subscribable<string | undefined>

    size: Subscribable<number>
    center: Subscribable<number>
    radius: Subscribable<number>

    strokeWidth: Subscribable<number>
    strokeDashArray: Subscribable<string>
    strokeDashOffset: Subscribable<number>
    backgroundStrokeDashOffset: Subscribable<number>

    isReady: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: ProgressRingVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        const value = ko.flattenComputed(config.value, 0);
        this.strokeWidth = ko.flattenComputed(config.strokeWidth, 2);
        this.size = ko.flattenComputed(config.size, 120);
        this.color = ko.flattenComputed(config.color, '#fff');
        this.backgroundColor = ko.flattenComputed(config.backgroundColor);

        this.center = ko.pureComputed(() => this.size() / 2);
        this.radius = ko.pureComputed(() => this.center() - this.strokeWidth() / 2);
        const circumference = ko.pureComputed(() => this.radius() * 2 * Math.PI);
        this.strokeDashArray = ko.pureComputed(() => circumference() + ' ' + circumference());
        this.strokeDashOffset = ko.pureComputed(() => circumference() - value() / 100 * circumference());
        this.backgroundStrokeDashOffset = ko.pureComputed(() => -value() / 100 * circumference());

        this.isReady = ko.pureComputed(() => this.radius() > 0);

        ko.applyBindingsToNode(info.element, {
            'css': {
                'progress-ring': true
            },

            'style': {
                'width': this.size.toPx(),
                'height': this.size.toPx()
            }
        });
    }
}